<template>
     <div class="pay_div"> 
          <div class="d-flex flex-column flex-root p-sm-10 p-0">
               <div class="d-flex flex-column flex-lg-row flex-column-fluid bg-body rounded-4">
                    <div class="d-flex flex-lg-row-fluid">
                         <div class="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
                              <!-- <h4 class="black-text fs-2qx fw-bold text-center mb-7">
                                   Please do not click back button or close or refresh page
                              </h4> -->
                              <img class="mx-auto mw-100 w-150px w-lg-350px mb-10 mb-lg-20 hideImage" src="https://cdn.digicollect.com/cdn/posv2/payment-img.svg" alt="payment image" />
                         </div>
                    </div>
                    <div class="d-flex flex-column-fluid flex-lg-row-auto justify-content-center m-sm-12 m-5">
                         <div class="bg-body-pay d-flex flex-center rounded-4 w-md-400px">
                              <div class="w-md-380px">
                                   <div class="w-100">
                                        <h2 class="heading h8 mb-0 black-text">DigiCollect POS Payment</h2>
                                        <!-- <img class="img-fluid" src="https://digicollect.com/assets/images/logo/digilogo.png" alt="DigiCollect-Logo-Media" style="width: 220px;margin: auto;"> -->
                                        <h1 class="fs-16 mx-2 mt-5 mb-5 d-flex align-items-center flex-wrap">
                                             <span class="mr-auto fw-bold  black-text">Amount to be Paid :</span> 
                                             <span class="amountDiv">{{total_amount}}</span>
                                        </h1>
                                        <iframe id="tokenframe" name="tokenframe" src="https://boltgw-uat.cardconnect.com/itoke/ajax-tokenizer.html?useexpiry=true&usecvv=true&enhancedresponse=true&formatinput=true&autofocus=true&invalidcvvevent=true&invalidexpiryevent=true&invalidinputevent=true&css=%40font-face%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20src%3A%20url(https%3A%2F%2Ffonts.googleapis.com%2Fcss2%3Ffamily%3DPoppins%3Aital%2Cwght%400%2C100%3B0%2C200%3B0%2C400%3B0%2C500%3B0%2C600%3B0%2C700%3B0%2C800%3B1%2C100%3B1%2C200%26display%3Dswap)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20%27Poppins%27%2C%20%27Helvetica%20Neue%27%2C%20sans-serif%20!important%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7Dbody%7B%0Afont-family%3A%20%27Poppins%27%2C%20%27Helvetica%20Neue%27%2C%20sans-serif%20!important%3B%0A%7D%0A.error%7B%0A%09%09%09color%3A%23D32F2F%20!important%3B%09%7D%0A%09%09input%23ccnumfield%20%7B%0A%09%09%09display%3Ablock%3Bmargin-bottom%3A30px%3Bwidth%3A335px%3Bheight%3A34px%3Bpadding%3A2px%2012px%3Bfont-size%3A14px%3Bline-height%3A1.42857143%3Bbackground-color%3A%23fff%3Bbackground-image%3Anone%3Bborder%3A1px%20solid%20%23676767%3Bborder-radius%3A6px%3B%0A%09%09%7D%0A%09%09label%23cccardlabel%20%7B%0A%09%09%09color%3A%20%23000%3Bdisplay%3A%20inline-block%3Bmax-width%3A%20100%25%3Bmargin-bottom%3A%2010px%3Bfont-weight%3A%20700%3Bfont-size%3A%2015px%3B%0A%09%09%7D%0A%09%09label%23ccexpirylabel%20%7B%0A%09%09%09color%3A%20%23000%3Bdisplay%3A%20block%3Bmargin-bottom%3A%2010px%3Bfont-weight%3A%20700%3Bfont-size%3A%2015px%3B%0A%09%09%7D%0A%09%09label%23cccvvlabel%20%7B%0A%09%09%09color%3A%20%23000%3Bdisplay%3A%20block%3Bmargin-bottom%3A%2010px%3Bfont-weight%3A%20700%3Bfont-size%3A%2015px%3B%0A%09%09%7D%0A%09%09select%23ccexpirymonth%20%7B%0A%09%09%09width%3A165px%3Bheight%3A40px%3Bmargin-bottom%3A30px%3Bpadding%3A6px%2012px%3Bfont-size%3A14px%3Bline-height%3A1.42857143%3Bcolor%3A%23303031%3Bbackground-color%3A%23fff%3Bbackground-image%3Anone%3Bborder%3A1px%20solid%20%23676767%3Bborder-radius%3A6px%3B%0A%09%09%7D%0A%09%09select%23ccexpiryyear%20%7B%0A%09%09%09margin-left%3A%2015px%3Bmargin-bottom%3A30px%3Bwidth%3A165px%3Bheight%3A40px%3Bpadding%3A6px%2012px%3Bfont-size%3A14px%3Bline-height%3A1.42857143%3Bcolor%3A%23303031%3Bbackground-color%3A%23fff%3Bbackground-image%3Anone%3Bborder%3A1px%20solid%20%23676767%3Bborder-radius%3A6px%3B%0A%09%09%7D%0A%09%09input%23cccvvfield%20%7B%0A%09%09%09display%3Ablock%3Bwidth%3A140px%3Bheight%3A34px%3Bpadding%3A2px%2012px%3Bfont-size%3A14px%3Bline-height%3A1.42857143%3Bbackground-color%3A%23fff%3Bbackground-image%3Anone%3Bborder%3A1px%20solid%20%23676767%3Bborder-radius%3A6px%3B%0A%09%09%7Dbr%20%7B%0A%20%20%20%20display%3A%20none%3B%0A%7D" scrolling="no" width="100%" height="280" frameborder="0"></iframe>
                                        <h1 id="global_error" class="text-danger fs-14 global-error-class">
                                             <!-- Please check and fill the correct details. -->
                                        </h1>
                                        <div class="d-flex ml-1 mb-7">
                                             <div class="form-group buttonsBlock">
                                                  <button type="button" @click="$router.go(-1)" class="btnCancel">
                                                       CANCEL
                                                  </button>
                                                  <button type="submit" :disabled="submit_api_in_progress" id="pay_btn" @click="Pay" class="btnSubmit">
                                                       <span class="pr-2">
                                                            <img src="https://cdn.digicollect.com/cdn/posv2/pay-img.svg" />
                                                       </span>
                                                       PAY
                                                  </button>
                                             </div>
                                        </div>
                                        <input type="hidden" name="token" id="token" required/>
                                        <!-- <input type="hidden" name="amount" value="{{data.amount}}" required/>
                                        <input type="hidden" name="order_id" value="{{data.order_id}}" required/> -->
                                        <input type="hidden" name="expiry" id="expiry" required/>
                                        <input type="hidden" name="cvv" id="cvv" required/>
                                        <!-- <button type="submit">Submit</button> -->

                                        <sweet-modal ref="success_modal" icon="success">{{ modal_msg }}</sweet-modal>
                                        <sweet-modal ref="warning_modal" icon="warning">{{ modal_msg }}</sweet-modal>
                                   </div>
                              </div>
                              <div v-if="api_call_in_progress" class="checkoutLoader">
                                   <div class="LoaderPlacement">
                                        <div class="digi-table-loader inverse">
                                             <div></div>
                                             <div></div>
                                             <div></div>
                                             <div></div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
          <payment-msg-modal-b-2-c v-if="payment_status_modal" modal_name="paymentMsgModal" :order_id="order_id" :order_type="order_type" @hidePayModal="hidePayModal" ></payment-msg-modal-b-2-c>
          <payment-msg-page-close-warning-modal modal_name="paymentMsgPageCloseWarningPopup" ></payment-msg-page-close-warning-modal>
     </div>
</template>

<script>
import paymentDeviceAPI from './mixins/paymentDeviceAPI'
import PaymentMsgModalB2C from "./PaymentMsgModalB2C";
import PaymentMsgPageCloseWarningModal from "./PaymentMsgPageCloseWarningModal";
import {
     SweetModal
} from 'sweet-modal-vue'
import { EventBus } from './eventBus/nav-bar-event';
export default {
     mixins: [paymentDeviceAPI],
     data(){
          return{
               order_id: '',
               order_type: '',
               modal_msg: '',
               api_call_in_progress: false,
               payment_status_modal: false,
               total_amount: 0,
               submit_api_in_progress: false,
          }
     },
     components: {
          SweetModal,
          PaymentMsgModalB2C,
          PaymentMsgPageCloseWarningModal
     },
     methods:{
          async paySuccess() {
               this.$modal.show('paymentMsgPageCloseWarningPopup')
               setTimeout(() => {
                    this.$modal.hide('paymentMsgPageCloseWarningPopup');
                    this.paySuccessConfirm()
               },2000);
          },
          /**
           * This method or function is used to pay the amount and do the payment using payment gateway
           * @param {expiry} - expiry is the Boolean
           * @param {token} - token is the Boolean
           * @param {order_id} - order_id is the String
           * @returns {response} - gets the Result
           */
          async paySuccessConfirm() {
               this.payment_status_modal = true;
               setTimeout(() => {
                    this.$modal.show('paymentMsgModal')
               },500);
               try{
                    this.submit_api_in_progress = true;
                    var expiry = document.getElementById('expiry');
                    var token = document.getElementById('token').value;
                    let exp_date = expiry.value.slice(4,) + '/' + expiry.value.slice(2,4)
                    let payload = {
                         order_id: this.order_id,
                         expiry: exp_date,
                         token: token
                    }
                    let res = await this.payAmount(payload);
                    // console.log(res)
                    setTimeout(() => {
                         EventBus.$emit("payment_status_success_failure", 'success')
                    }, 1000);
               }
			catch(error){
                    setTimeout(() => {
                         EventBus.$emit("payment_status_success_failure", 'failure')
                    }, 1000);
                    this.payment_status_modal = true;
                    setTimeout(() => {
                         this.$modal.show('paymentMsgModal')
                    },500);
               }
          },
          hidePayModal(){
               this.payment_status_modal = false;
               setTimeout(() => {
                    this.$modal.hide('paymentMsgModal')
               },500);
          },
          async Pay(){
               try {
                    this.$http.get("/cashier/is_cashier_session_active").then(res => {
                    this.modal_msg = res.data.reason;
                         if (res.data.status_id == 1) {
                              this.paySuccess();
                         } else {
                              this.$toasted.global.error(res.data.reason);
                              this.$router.go(-1);
                         }
                    });
               } catch (reason) {
                    this.$toasted.global.error(reason);
               }
		}
     },
     beforeRouteLeave (to, from, next) {
          let message = "<div class='d-block'>Order is in progress Data would be lost, Do you want to proceed?</div>";
          // <img src='/static/images/exclamation-yellow.svg' class='d-block h-100px mx-auto mb-5'/><br>
          let options = {
               html: true,
               loader: false,
               reverse: false, // switch the button positions (left to right, and vise versa)
               okText: 'Yes',
               cancelText: 'No',
               animation: 'fade',
               type: 'basic',
               verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
               verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
               backdropClose: true,
          };
          this.$dialog.confirm(message, options)
          .then( () => {
               next();
          })
          .catch( ()=> {
               next(false);
          });
     },
     mounted(){
          var token = document.getElementById('token');
          let pay_btn = document.getElementById('pay_btn');
          if(token.value == ''){
               pay_btn.disabled = true
               pay_btn.style.border = '1px solid #999999'
               pay_btn.style.backgroundColor = '#cccccc'
               pay_btn.style.cursor = 'not-allowed'
          }
          document.cookie = "SameSite=None"
          window.addEventListener('message', function(event) {
               if(!event.data.source){
                    console.log("Event Triggered!", event.data)
                    var eventData = JSON.parse(event.data);
                    var token = document.getElementById('token');
                    token.value = eventData.message;
                    var expiry = document.getElementById('expiry');
                    expiry.value = eventData.expiry;
                    var cvv = document.getElementById('cvv');
                    cvv.value = eventData.cvv;
                    let global_error = document.getElementById('global_error');
                    let pay_btn = document.getElementById('pay_btn');
                    if(token.value != '' && expiry.value != 'undefined'){
                         pay_btn.disabled = false
                         global_error.style.display = 'none'
                         global_error.innerText = ''
                         pay_btn.style.border = '1px solid #00448f'
                         pay_btn.style.backgroundColor = '#00448f'
                         pay_btn.style.cursor = 'pointer'
                    } else {
                         console.log(event.data.errorMessage)
                         global_error.style.display = 'block'
                         global_error.innerText = eventData.errorMessage || ''
                         pay_btn.disabled = true
                         pay_btn.style.border = '1px solid #999999'
                         pay_btn.style.backgroundColor = '#cccccc'
                         pay_btn.style.cursor = 'not-allowed'
                    }
               } 
          }, false);
          this.order_id = this.$route.query.order_id
          this.order_type = this.$route.query.order_type
          this.total_amount = this.$route.query.total_amount
     }
}

</script>

<style scoped>
     .global-error-class {
          display: none;
     }
     .pay_div .error{
          color:#D32F2F;
          display:block;width:360px;height:34px;padding:2px 12px;font-size:14px;line-height:1.42857143;background-color:#fff;background-image:none;border:1px solid #676767;border-radius:4px;
     }
     .pay_div .heading {
        font-size: 20px;
        font-weight: 700;
        margin-top: 20px;
        padding-bottom: 15px;
        text-align: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.16);
        text-transform: uppercase;
    }
     .pay_div .form-group {
          margin-bottom: 15px;
     }
     .pay_div .buttonsBlock {
          max-width: 360px;width:100%;margin-top: 4px;text-align: center;
     }
     .pay_div .card {
          position: relative;
          display: flex;
          flex-direction: column;
          min-width: 0;
          word-wrap: break-word;
          background-color: transparent;
          background-clip: border-box;
          border: 0px solid transparent;
          border-radius: 0rem;
          box-shadow:none !important;
     }
     .pay_div .px-4 {
          padding-right: 1.5rem !important;
          padding-left: 1.5rem !important;
     }
     .pay_div .card {
          max-width: 360px;
          margin: auto;
          border-radius: 0px;
          padding: 0px;
     }
     .pay_div .container .h8 {
          font-size: 24px;
          font-weight: 800;
          text-align: center;
     }

    .flex-root {
        flex: 1;
    }
    .flex-column {
        flex-direction: column;
    }
    .w-150px {
        width: 150px !important;
    }
    .fs-2qx {
        font-size: 18px !important;
        padding: 2px 45px;
    }
    .flex-column-fluid {
        flex: 1 0 auto;
    }
    .flex-center {
        justify-content: center;
        align-items: center;
    }
    .mw-100 {
        max-width: 100% !important;
    }
    .black-text {
        color: #020a12;
    }
    .rounded-4 {
        border-radius: 1rem !important;
    }
    .bg-body {
        background-color: #fff !important;
    }
    .bg-body-pay {
        border-radius: 4px;
        box-shadow: 0 1.5px 6px 0 rgba(0, 0, 0, 0.47);
        background-color: #fff;
    }
    .amountDiv {
        background: #f2f2fb;
        border-radius: 2px;
        color: #00448b;
        letter-spacing: 0.18px;
        padding: 6px 8px;
        width: 145px;
        text-align: right;
        font-weight: 700 !important;
    }
    .fw-700 {
        font-weight: 700 !important;
    }
    .buttonsBlock {
          width: 360px;margin-top: 4px;text-align: center;
     }
    .btnCancel {
        display:inline-block;
        margin-right: 20px;
        margin-bottom:0;
        font-weight:600 !important;
        text-align:center !important;
        white-space:nowrap;
        vertical-align:middle;
        -ms-touch-action:manipulation;
        touch-action:manipulation;
        cursor:pointer;
        color: #fff;
        background-color: #d72c34;
        border:1px solid #d72c34;
        padding:10px 24px !important;
        font-size:15px !important;
        line-height:1.42857143;
        border-radius:6px;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        width: 170px;
    }
    .btnSubmit {
        display:inline-block;margin-bottom:0;font-weight:600 !important;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;color: #000;background-image: linear-gradient(315deg, #fccb4a -30%, #f0712a 48%);border: 0 !important; outline: 0 none !important; padding:10px 24px !important;font-size:15px;line-height:1.42857143;border-radius:6px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width: 170px;
    }
    @media (min-width: 992px) {
        .flex-lg-row {
            flex-direction: row !important;
        }
        .flex-lg-row-fluid {
            flex: 1 auto;
            min-width: 0;
        }
        .pb-lg-10 {
            padding-bottom: 2.5rem !important;
        }
        .mb-lg-20 {
            margin-bottom: 5rem !important;
        }
        .w-lg-350px {
            width: 350px !important;
        }
        .flex-lg-row-auto {
            flex: 0 0 auto;
        }
        .justify-content-lg-end {
            justify-content: flex-end !important;
        }
    }
     .w-md-400px {
          width: 450px !important;
     }
     .w-md-380px {
          width: 380px !important;
     }

	@media (max-width: 350px) {
          .fs-2qx {
               font-size: 14px;
               padding: 2px 5px;
          }
          .p-10 {
               padding: 2rem !important;
          }
          .hideImage {
               display: none;
          }
     }
</style>
